/** Where the operator is looking, in fractions of the displayed page, so that it survives a change
 * of viewport size and scale (entering and leaving the full-screen viewer). */
export type ViewCenter={identity:string;x:number;y:number};
export type ViewMemory={current:ViewCenter|null};

type Box={width:number;height:number};
/** `left`/`top` are the margins that centre a page smaller than the viewport. */
type PageBox=Box&{left:number;top:number};

/** Nothing to remember while the whole page is visible: any position shows the same thing. */
export function viewCenter(scroll:{left:number;top:number},viewport:Box,page:PageBox):{x:number;y:number}|null {
  if(!(page.width>0&&page.height>0)) return null;
  if(page.width<=viewport.width+1 && page.height<=viewport.height+1) return null;
  const clamp=(value:number)=>Math.max(0,Math.min(1,value));
  return {x:clamp((scroll.left+viewport.width/2-page.left)/page.width),y:clamp((scroll.top+viewport.height/2-page.top)/page.height)};
}

export function scrollForCenter(center:{x:number;y:number},viewport:Box,page:PageBox):{left:number;top:number} {
  return {left:Math.max(0,center.x*page.width+page.left-viewport.width/2),top:Math.max(0,center.y*page.height+page.top-viewport.height/2)};
}

/** Escape cancels the step in progress (a frame being drawn) before it may close the viewer. */
export function cancelOnEscape(event:{key:string;preventDefault():void;stopPropagation():void},cancel:()=>void):boolean {
  if(event.key!=='Escape') return false;
  event.preventDefault();
  event.stopPropagation();
  cancel();
  return true;
}
